import type { Session } from '@entregas/api';
import { useDb } from '@entregas/api/react';
import { useQueryClient } from '@tanstack/react-query';
import { createContext, type ReactNode, useContext, useEffect, useState } from 'react';

interface EstadoSessao {
  sessao: Session | null;
  carregando: boolean;
}

const ContextoSessao = createContext<EstadoSessao>({ sessao: null, carregando: true });

/** Acompanha login/logout do Supabase. Ao sair, limpa o cache (dados da loja não vazam). */
export function ProvedorSessao({ children }: { children: ReactNode }) {
  const db = useDb();
  const qc = useQueryClient();
  const [estado, setEstado] = useState<EstadoSessao>({ sessao: null, carregando: true });

  useEffect(() => {
    let ativo = true;
    db.auth.getSession().then(({ data }) => {
      if (ativo) setEstado({ sessao: data.session, carregando: false });
    });
    const { data } = db.auth.onAuthStateChange((evento, sessao) => {
      if (evento === 'SIGNED_OUT') qc.clear();
      setEstado({ sessao, carregando: false });
    });
    return () => {
      ativo = false;
      data.subscription.unsubscribe();
    };
  }, [db, qc]);

  return <ContextoSessao.Provider value={estado}>{children}</ContextoSessao.Provider>;
}

export function useSessao(): EstadoSessao {
  return useContext(ContextoSessao);
}
